import React, { useEffect, useState } from 'react';
import { defineMessages } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loading from '@components/common/loading';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { showErrorMessage, showSucsessMessage } from '@services/notifyService';
import { getDetailRestaurantSuccess } from '@store/actions/restaurant';
import { Card } from 'antd';

import GeneralSettingForm from './GeneralSettingForm';

const message = defineMessages({
    title: 'General',
    fetchError: 'Failed to fetch restaurant data',
    updateSuccess: 'Update restaurant successfully',
    objectName: 'restaurant',
});

const GeneralSettingPage = ({ updateData, updateRestaurantSuccess, ...props }) => {
    const translate = useTranslate();
    const [ isGetDetailLoading, setIsGetDetailLoading ] = useState(false);
    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const [ isChanged, setIsChanged ] = useState(false);
    const params = useParams();
    const { restaurantId } = useParams();
    const dispatch = useDispatch();
    const [ dataDetail, setDataDetail ] = useState(null);
    let backupTimezone = '';

    const objectName = translate.formatMessage(message.objectName);

    const {
        execute: executeGet,
        data: dataRestaurant,
        loading: fetchLoading,
    } = useFetch(apiConfig.restaurant.getById, {
        immediate: false,
    });

    const { execute: executeUpdate, loading: updateLoading } = useFetch(apiConfig.restaurant.updateByCustomer, {
        immediate: false,
    });

    useEffect(() => {
        const restaurantId = params.restaurantId;
        if (restaurantId) {
            setIsGetDetailLoading(true);
            executeGet({
                pathParams: { id: restaurantId },
                onCompleted: (response) => {
                    const restaurantData = response.data;
                    const parsedSettings = JSON.parse(restaurantData.settings);
                    setDataDetail({
                        ...restaurantData,
                        settings: parsedSettings,
                    });
                    backupTimezone = parsedSettings.timezone;
                    setIsGetDetailLoading(false);
                },
                onError: (error) => {
                    showErrorMessage(translate.formatMessage(message.fetchError), translate);
                    setIsGetDetailLoading(false);
                },
            });
        }
    }, [ props.match?.params?.id ]);

    const onSave = (payload) => {
        setIsSubmitting(true);
        executeUpdate({
            data: payload,
            onCompleted: (responseData) => {
                executeGet({
                    pathParams: { id: restaurantId },
                    onCompleted: (response) => {
                        dispatch(getDetailRestaurantSuccess({ payload: { data: response.data } }));
                    },
                });
                showSucsessMessage(translate.formatMessage(message.updateSuccess), translate);
                setIsChanged(false);
                setIsSubmitting(false);

                const updatedSettings = JSON.parse(payload.settings);
                setDataDetail({
                    ...dataDetail,
                    ...payload,
                    settings: updatedSettings,
                });
            },
            onError: (error) => {},
        });
    };

    if (isGetDetailLoading || fetchLoading || !dataDetail) {
        return <Loading />;
    }

    return (
        <div className="basic-form-page" style={{ width: '98%', marginLeft: '20px', marginTop: '20px' }}>
            <Card title={translate.formatMessage(message.title)} bordered={false}>
                <GeneralSettingForm
                    formId={`form-${objectName}`}
                    onSubmit={onSave}
                    dataDetail={dataDetail}
                    settingObj={dataDetail.settings || {}}
                    restaurantName={dataDetail.restaurantName || ''}
                    setIsChangedFormValues={setIsChanged}
                    isSubmitting={isSubmitting}
                    isChanged={isChanged}
                />
            </Card>
        </div>
    );
};

export default GeneralSettingPage;
